import { gql } from "@apollo/client";

// Eurail Ticket queries starts here
export const ET_STATION_LIST = gql`
  query eurailStations($input: String) {
    eurailStations(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;
export const ET_STATION_TO_LIST = gql`
  query eurailStationsTo($input: String) {
    eurailStations(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const ET_SEARCH = gql`
  mutation eurailTicketSearch($input: String!) {
    eurailTicketSearch(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const ET_SEARCH_RESULT = gql`
  query eurailTicketList($input: String!) {
    eurailTicketList(ts: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const ET_PRE_BOOK = gql`
  mutation eurailTicketPrebook($input: String!) {
    eurailTicketPrebook(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const ET_CHECKOUT = gql`
  mutation eurailTicketCheckout($input: String!) {
    eurailTicketCheckout(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;
// Eurail Ticket queries ends here

// Eurail Pass queries starts here
export const EURO_COUNTRIES = gql`
  query eurailCountries($input: String) {
    eurailCountries(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const EP_SEARCH = gql`
  mutation postURailPassSearch($input: String!) {
    postURailPassSearch(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const EP_SEARCH_RESULT = gql`
  query uRailPassList($input: String!) {
    uRailPassList(ts: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const EP_PRE_BOOK = gql`
  mutation postPassPrebook($input: String!) {
    postPassPrebook(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const EP_CHECKOUT = gql`
  mutation postURailPassCheckOut($input: String!) {
    postURailPassCheckOut(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;
// Eurail Pass queries ends here

export const EURAIL_CONFIG_KEY_QUERY = gql`
  query ($input: String!) {
    configValueByKey(config_key: $input) {
      correlationId
      messageCode
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const EURAIL_BOOKING_DETAILS = gql`
  query ($bid: String!) {
    eurailBookingDetailsByBid(bid: $bid) {
      messageCode
      successTypeCode
      messageDescription
      responseData
    }
  }
`;

export const AGENT_EURAIL_BOOKING_DETAILS = gql`
  query ($bid: String!, $agent_id: Long!) {
    agentEurailBookingDetails(bid: $bid, agent_id: $agent_id) {
      messageCode
      successTypeCode
      messageDescription
      responseData
    }
  }
`;
export const EURAIL_SEGMENT_CHARGES_QUERY = gql`
  mutation eurailSegmentCharges($input: String!) {
    eurailSegmentCharges(input: $input) {
      correlationId
      failedTypeCode
      messageCode
      messageDescription
      orderByData
      responseData
      successTypeCode
      totalRecords
    }
  }
`;